import type { Dispatch, SetStateAction } from 'react';

export function toggleAccordion(
  setOpenAccordions: Dispatch<SetStateAction<number[]>>,
  accordionId: number
) {
  setOpenAccordions((previousOpenAccordions) => {
    const newOpenAccordions = [...previousOpenAccordions];
    const indexOfAccordion = previousOpenAccordions.indexOf(accordionId);
    if (indexOfAccordion === -1) {
      newOpenAccordions.push(accordionId);
      return newOpenAccordions;
    }
    newOpenAccordions.splice(indexOfAccordion, 1);
    return newOpenAccordions;
  });
}
